module.exports = __webpack_public_path__ + "img/feature-illustration-1.d72d2fa.svg";